import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React from "react";
import Spacing from "../../become-partner/spacing";
import "../styles/AppAccordion_style.css";

const Accordion = withStyles({
  root: {
    margin: 0,
    marginBottom: -77,
    backgroundColor: "#f2f3f5",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);
const AccordionSummary = withStyles({
  root: {
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      // margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: "white",
    marginBottom: -100
  },
}))(MuiAccordionDetails);


export default function AppAccordion({ data }) {

  return (
    <div className="accordion-container">
      <Spacing />
      <Accordion square defaultExpanded >
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <Typography style={styles.title}>{data.title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ul className="dashed">
            {data.content.map(l => (
              <li key={l}>{l}</li>
            ))}
          </ul>
        </AccordionDetails>
      </Accordion>
    </div>
  );

}

const styles = {
  title: {
    fontSize: 18,
    fontWeight: 50,
    color: "#28292a",
    lineHeight: 1.8,
    fontFamily: "Prompt",
  },
  content: {
    fontFamily: "Prompt",
    fontSize: 16,
    lineHeight: 2.25,
    letterSpacing: "normal",
    textAlign: "left",
    color: "#28292a",
  },
};
